import React from "react";
import {useClientContext} from "../../../context";
import {Button, Navbar} from "react-bootstrap";

export default () => {
    const {login} = useClientContext();

    return (
        <Navbar.Text>Для того чтобы оставлять комментарии, вам необходимо <Button onClick={login} bsStyle="link">авторизоваться</Button></Navbar.Text>
    );
}
